import * as React from "react"
const NotificationsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
  >
    <g clipPath="url(#a)">
      <g
        stroke="#B6B9C7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M6.214 9.76A5.752 5.752 0 0 1 11.998 4c3.168.024 5.704 2.656 5.704 5.832v.568c0 2.864.6 4.528 1.128 5.44a.64.64 0 0 1-.552.96H5.638a.64.64 0 0 1-.552-.96c.528-.912 1.128-2.576 1.128-5.44v-.64ZM9.398 16.8v.64a2.56 2.56 0 1 0 5.12 0v-.64" />
      </g>
      <circle cx={18} cy={5} r={3.5} fill="#E7502C" stroke="#fff" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default NotificationsIcon
